module.exports = __webpack_public_path__ + "static/media/freddy.8c5914e6.jpg";